import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Button } from 'reactstrap';
import * as Actions from '../../redux/actions';
import DataGrid from '../Components/DataGrid';
import Loading from '../Components/Loading';
import PageHeader from '../Components/PageHeader';
import Sensor from './Sensor/Sensor';
import { sensorConnected } from './Sensor/common/helpers';
import NewSensorModal from './Sensor/NewSensorModal';
import {
  currentOrgSensorsSelector,
  sensorIdSelector,
} from '../../selectors/sensorsSelectors';

import LoadingTable from '../Components/LoadingTable'

import './SensorsPageView.sass';

class SensorsPageView extends Component {
  constructor(props) {
    super(props);

    this.fetch = this.fetch.bind(this);
    this.viewSensor = this.viewSensor.bind(this);
    this.viewSensors = this.viewSensors.bind(this);
  }

  componentDidMount() {
    this.fetch();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.orgId !== this.props.orgId) {
      this.fetch();
      this.viewSensors();
    }
  }

  fetch() {
    this.props.dispatchFetchSensors(this.props.orgId);
  }

  viewSensor(sensorId) {
    const { gotoSensor, payload } = this.props;

    // Navigate to the Sensor sensorId View
    gotoSensor({ id: sensorId, payload });
  }

  viewSensors() {
    const { gotoSensors, payload } = this.props;

    // Navigate to the Sensors Page View
    gotoSensors(payload);
  }

  render() {
    const {
      meta = {},
      isFetching,
      sensors = [],
      loading = false,
      detailViewSensorId = null,
    } = this.props;

    const sensorsMeta = meta.sensors || {};

    if (detailViewSensorId) {
      return (
        <span className='dashboard sensors'>
          <PageHeader />
          <Sensor />
        </span>
      );
    }

    return (
      <React.Fragment>

        <NewSensorModal />

        <span className='dashboard sensors'>

          {loading && _.isEmpty(sensorsMeta) && (
            <div className="dashboard sensors">
              <div className="loading-div">
                <Loading />
              </div>
            </div>
          )}

          <PageHeader>
            <Button onClick={() => { this.props.addNewSensorShow(); }} datacy={'addNewSensorButton'}>
            Add New Sensor
            </Button>
          </PageHeader>

          <div className='row main-content'>

            <div className="total-sensors-count">
              Total number of sensors: <span data-cy={'sensorNumberCount'}>{sensors.length}</span>
            </div>
            {isFetching ? 
            <LoadingTable/>
            :
            <div className='sensors-table'>
              <DataGrid
                columnHeaders='sensorsHeaders'
                data={sensors}
                getTdProps={(state, rowInfo) => {
                  if (rowInfo && rowInfo.original) {
                    return {
                      onClick: (e, handleOriginal) => {
                        if (rowInfo.original.id) {
                          this.viewSensor(rowInfo.original.id);
                        }
                        if (handleOriginal) {
                          handleOriginal();
                        }
                      },
                      style: {
                        cursor: 'pointer',
                      },
                    };
                  }
                  return {};
                }}
                columns={[
                  {
                    id: 'connected',
                    filterable: false,
                    width: 90,
                    Cell: (row) => {
                      let status = null;

                      if (row.original && row.original.status) {
                        status = row.original.status;
                      }

                      const connected = sensorConnected(status);

                      const statusField = connected ? (
                        <span>
                          <span className="fas fa-circle text-success" />
                          <span>&nbsp;&nbsp;Yes</span>
                        </span>
                      ) : (
                        <span>
                          <span className="fas fa-circle text-danger" />
                          <span>&nbsp;&nbsp;No</span>
                        </span>
                      );

                      return (<div>{statusField}</div>);
                    },
                  }, {
                    id: 'name',
                    accessor: 'name',
                    filterable: false,
                  }, {
                    Header: 'Location',
                    filterable: false,
                    columns: [
                      {
                        Header: 'Name',
                        headerClassName: 'location-name-header',
                        accessor: 'location.name',
                        minWidth: 150,
                        maxWidth: 350,
                      },
                      {
                        Header: 'City',
                        headerClassName: 'location-city-header',
                        accessor: 'location.city',
                        maxWidth: 100,
                      },
                      {
                        Header: 'State',
                        headerClassName: 'location-state-header',
                        accessor: 'location.state',
                        width: 80,
                        headerStyle: { textAlign: 'center' },
                        style: { textAlign: 'center' },
                      },
                      {
                        Header: 'Country',
                        headerClassName: 'location-country-header',
                        accessor: 'location.country',
                        width: 80,
                        headerStyle: { textAlign: 'center' },
                        style: { textAlign: 'center' },
                      },
                    ],
                  }, {
                    id: 'Time Zone',
                    accessor: 'location.timezone',
                    filterable: false,
                    maxWidth: 235,
                  },
                ]}
              />
            </div>
            }
          </div>
        </span>
      </React.Fragment>
    );
  }
}

SensorsPageView.propTypes = {
  addNewSensorShow: PropTypes.func.isRequired,
  orgId: PropTypes.string.isRequired,
  data: PropTypes.shape({}),
  meta: PropTypes.shape({}),
  user: PropTypes.shape({}),
  payload: PropTypes.shape({}),
  loading: PropTypes.bool,
  detailViewSensorId: PropTypes.string,
  gotoSensor: PropTypes.func.isRequired,
  gotoSensors: PropTypes.func.isRequired,
  sensors: PropTypes.arrayOf(PropTypes.shape({})),
  dispatchFetchSensors: PropTypes.func.isRequired,
};

SensorsPageView.defaultProps = {
  user: {},
  payload: {},
  data: {},
  meta: {},
  loading: false,
  detailViewSensorId: null,
  sensors: [],
};

const mapStateToProps = (state) => {
  const orgSensors = currentOrgSensorsSelector(state);
  const detailViewSensorId = sensorIdSelector(state);

  // the way this reducer is set up is fun
  const { sensors: { sensors } } = state
  const { byOrg } = sensors

  return ({
    detailViewSensorId,
    sensors: orgSensors,
    isFetching: byOrg.isFetching
  });
};

const mapDispatchToProps = dispatch => ({
  addNewSensorShow: () => {
    const query = {
      addNewSensor: 'true',
    };
    dispatch(Actions.Page.pageWithQuery(query));
  },

  dispatchFetchSensors: (orgId) => {
    dispatch(Actions.Sensors.fetchSensors(orgId));
  },
  gotoSensor: ({ id, payload }) => {
    // Dispatch 'page' action
    dispatch({ type: 'PAGE', payload: { ...payload, id1: id } });
  },
  gotoSensors: (payload) => {
    const newPayload = { ...payload };
    delete newPayload.id1;

    dispatch({ type: 'PAGE', payload: newPayload });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SensorsPageView);
